import styled from 'styled-components';

import SmallDownload from '../../Icons/SmallDownload';

export const FileLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  align-items: center;
`;

export const FileNameLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 10px;
`;

export const FileName = styled.p<{ isAuthor: boolean }>`
  color: ${(props) => (props.isAuthor ? 'rgba(255, 255, 255, 0.56)' : 'rgba(109, 120, 131, 1)')};
  font-size: 12px;
  margin: 0;
  font-weight: 400;
  line-height: 266%;
  letter-spacing: 1px;
  text-transform: uppercase;
  max-width: 80%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Thumbnail = styled.img<{ $clickable: boolean }>`
  border-radius: 4px;
  max-width: 200px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;

export const StyledSmallDownload = styled(SmallDownload)<{ isAuthor: boolean }>`
  color: ${({ isAuthor, theme }) => (isAuthor ? 'rgba(255, 255, 255)' : theme.palette.primary.main)};
  font-size: 16px;

  margin-left: 4px;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;
